import { ITransferCollegesDatasource } from './../datasources/transfer_colleges_datasource';
import { College } from './../builders/college_builder';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-transfer')
  .factory('loadTransferSelectedCollegesCommand', (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCollegesDatasource: ITransferCollegesDatasource,
    ngCollegeBuilder: typeof College
  ): ICommand => {
    return defineCommand('loadTransferSelectedCollegesCommand', (deferred: ng.IDeferred<IQuery[]>,
                                                                 response: ng.IHttpPromiseCallbackArg<any>): void => {

      ngTransferCollegesDatasource.clear();

      ngTransferCollegesDatasource.write(response.data.results.colleges);

      deferred.resolve(
        QueryMediator.runQueries(
          ngTransferCollegesDatasource
        )
      );

    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_selected_colleges_command.ts